import { useCallback, useEffect, useState } from 'react';
import Pagination from '../../components/pagination/Pagination';
import './orgBooking.css';
import { bookingCount, fetchOrgBooking, getBookingsToday, getTrips } from './orgBookingFun/fetchOrgBookings';
import ReactLoading from 'react-loading';
import EmptyPage from '../../components/empty-page/emptyPage';
import fetchTripDates from './orgBookingFun/fetchTripDates';
import Dialog from '../../components/dialogModal/dialogModal';
import { sendMessage } from './orgBookingFun/sendMessage';
import { standardDate } from '../../utils/formatDate';
import { truncateText } from '../../utils/maskFields';
import { useSearchParams } from 'react-router-dom';
import { getTransationCharges } from '../../utils/getAmountWithTransaction';
import BookingStats from '../supBooking/bookingStats/BookingStats';

const OrgBooking = () => {
    const [bookings, setBookings] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedType = searchParams.get('type') || 'upcoming';
    const datesType = searchParams.get('datesType') || 'fixed';
    const group = searchParams.get('group') || 'backpacking';
    const selectedTrip = searchParams.get('trip') || '';
    const selectedDate = searchParams.get('date') || '';
    const pageNumber = Number(searchParams.get('page')) || 1;
    const limit = 10;
    const offSet = (pageNumber - 1) * limit;
    const [todaysBookings, setTodaysBookings] = useState('');
    const [trips, setTrips] = useState([]);
    const [stats, setStats] = useState({});
    const [loading, setLoading] = useState(false);
    const [tripDates, setTripDates] = useState([]);
    const [modal, setModal] = useState(false);
    const [rowData, setRowData] = useState({});
    const [messageType, setMessageType] = useState([]);
    const [messageData, setMessageData] = useState({
        msgType: 'whatsApp',
        whatsApp: '',
        message: ''
    });
    const [totalCount, setTotalCount] = useState(0);
    const totalData = totalCount;
    const totalPages = Math.ceil(totalData / limit);
    const tableHeader = [
        'Trip Name',
        'Name',
        'Start City',
        'Pick Up',
        'Booked On',
        'Payment',
        'Seats',
        'Rooms',
        'Transport',
        'Booked Via',
        'People',
        'Ticket Status'
    ];

    const customTabelHeadre = [
        'Trip Name',
        'Name',
        'Start City',
        'Pick Up',
        'Booked On',
        'Seats',
        'Rooms',
        'Bed',
        'Payment',
        'IsGroup',
        'Vehicle',
        'Booked Via',
        'People',
        'Ticket Status'
    ];

    const dummyMessageType = [
        { value: 'whatsApp', name: 'WhatsApp' },
        { value: 'rate', name: 'Rate' },
        { value: 'custom', name: 'Custom' }
    ];
    const [rowClickId, setRowClickId] = useState(0);
    const [customRowClickId, setCustomRowClickId] = useState(0);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        const fetchBookingData = async () => {
            fetchOrgBooking(
                limit,
                setBookings,
                setStats,
                setLoading,
                offSet,
                selectedTrip,
                selectedDate,
                selectedType,
                datesType,
                group
            );
            getBookingsToday(setTodaysBookings, setLoading);
            getTrips(setTrips, datesType, group, setLoading);
        };
        fetchBookingData();
        setMessageType(dummyMessageType);
        //eslint-disable-next-line
    }, [selectedType, selectedTrip, selectedDate, offSet, limit, datesType, group]);

    useEffect(() => {
        if (!selectedTrip) return;
        fetchTripDates(selectedTrip, setTripDates, selectedType, setLoading);
    }, [selectedType, selectedTrip]);

    const updateURL = useCallback(
        (params) => {
            const current = Object.fromEntries([...searchParams]);

            Object.keys(params).forEach((key) => {
                if (params[key] === '' || params[key] === null) {
                    delete current[key];
                } else {
                    current[key] = params[key];
                }
            });
            setSearchParams(current);
        },
        [searchParams, setSearchParams]
    );

    useEffect(() => {
        if (!totalPages) return;

        if (pageNumber > totalPages) {
            updateURL({ page: totalPages });
        }
        //eslint-disable-next-line
    }, [totalPages, pageNumber, updateURL]);

    useEffect(() => {
        bookingCount(setTotalCount, setLoading, selectedTrip, selectedDate, selectedType, datesType, group);
    }, [selectedType, selectedTrip, selectedDate, datesType, group]);

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            updateURL({ page: number });
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        if (rowClickId !== 0) {
            window.open(`/org/trip/date/${rowClickId}`, '_blank');
            setRowClickId(0);
        }
    }, [rowClickId]);

    useEffect(() => {
        if (customRowClickId !== 0) {
            const bookingsById = bookings.find((bookingsItem) => bookingsItem?._id === customRowClickId);
            const packId = bookingsById?.packId?._id;
            const startDate = bookingsById?.startDate.split('T')[0];
            window.open(`/org/trip/date/${packId}/${startDate}`);
            setRowClickId(0);
        }
    }, [customRowClickId]);

    const getTripDetails = (row) => {
        return (
            <div className='bookingTitleArea'>
                <div>{row?.packId?.title ?? 'N/A'}</div>
                <div>
                    {standardDate(row.startDate.split('T')[0])} (
                    {`${row?.packId?.days ?? '(N/A)'}D/${row?.packId?.nights ?? '(N/A)'}N`})
                </div>
            </div>
        );
    };

    const getUserDetails = (row) => {
        return row.userDetails.map(function (user, userKey) {
            return (
                <div key={userKey}>
                    <span>{user?.name ?? 'N/A'}, </span>
                    <span>{user?.age ?? 'N/A'} years, </span>
                    <span>{user?.sex ?? 'N/A'}, </span>
                    <span>{user?.phoneNumber ?? 'N/A'}</span>
                </div>
            );
        });
    };
    // const visibleTableHeader =
    //     selectedType === 'upcoming' ? tableHeader : tableHeader.filter((header) => header !== 'Action');
    return (
        <>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='bookingSticky'>
                <div className='alignCenter'>
                    <h2 className='orgBookingHeading'>Bookings</h2>
                    <div className='orgFilterWrapper'>
                        {/* <div className='orgTripDateInfo mb-2'>
                            <span className='orgTripDateSpan'>Bookings Today</span>
                            <span className='orgTripDateSpan'>{todaysBookings.bookedToday ?? '0'}</span>
                        </div> */}
                    </div>
                </div>
                <BookingStats stats={stats} />
                <div className='orgBookingFilters'>
                    <select
                        name='type'
                        id='type'
                        className='select'
                        value={selectedType}
                        onChange={(e) => {
                            updateURL({ type: e.target.value, page: 1 });
                        }}
                    >
                        <option value='upcoming'>Upcoming</option>
                        <option value='completed'>Completed</option>
                    </select>
                    <select
                        name='type'
                        id='type'
                        className='select'
                        value={datesType}
                        onChange={(e) => {
                            updateURL({ datesType: e.target.value, page: 1 });
                        }}
                    >
                        <option value='fixed'>Fixed</option>
                        <option value='custom'>Custom</option>
                    </select>
                    <select
                        name='type'
                        id='type'
                        className='select'
                        value={group}
                        onChange={(e) => {
                            updateURL({ group: e.target.value, page: 1 });
                        }}
                    >
                        <option value='backpacking'>Backpacking</option>
                        <option value='vehicle'>Vehicle</option>
                    </select>
                    {selectedType && (
                        <select
                            name='trip'
                            id='trip'
                            className='select'
                            value={selectedTrip}
                            onChange={(e) => {
                                updateURL({ trip: e.target.value, page: 1 });
                            }}
                        >
                            <option value=''>Select Trip</option>
                            {trips.map((trip) => (
                                <option value={trip._id} key={trip._id}>
                                    {trip.title}
                                </option>
                            ))}
                        </select>
                    )}
                    {selectedType && selectedTrip && datesType === 'fixed' && (
                        <select
                            name='date'
                            id='date'
                            className='select'
                            value={selectedDate}
                            onChange={(e) => {
                                updateURL({ date: e.target.value, page: 1 });
                            }}
                        >
                            <option value=''>Select Date</option>
                            {tripDates.map((date) => (
                                <option value={date._id} key={date._id}>
                                    {date.startDate.split('T')[0]}
                                </option>
                            ))}
                        </select>
                    )}
                </div>
            </div>
            <div className='orgBookingContainer'>
                {bookings?.length === 0 && !loading ? (
                    <EmptyPage />
                ) : (
                    <div className='tableContainer'>
                        <table className='table'>
                            <thead className='tableHead'>
                                <tr>
                                    {datesType === 'fixed'
                                        ? tableHeader.map((head, headIndex) => {
                                              return <th key={headIndex}>{head}</th>;
                                          })
                                        : customTabelHeadre.map((head, headIndex) => {
                                              return <th key={headIndex}>{head}</th>;
                                          })}
                                </tr>
                            </thead>
                            <tbody>
                                {bookings?.map((row, rowIndex) => {
                                    return (
                                        <tr
                                            key={rowIndex}
                                            className={'tableBodyRow allowCLick'}
                                            onClick={() =>
                                                datesType === 'fixed'
                                                    ? setRowClickId(row?.packDateId)
                                                    : setCustomRowClickId(row?._id)
                                            }
                                        >
                                            {datesType === 'fixed' ? (
                                                <>
                                                    <td>{getTripDetails(row)}</td>
                                                    <td>{row?.userDetails[0]?.name}</td>
                                                    <td>{row.startCity ?? 'N/A'}</td>
                                                    <td>{truncateText(row.pickupLocation, 40) ?? 'N/A'}</td>
                                                    <td>{standardDate(row.createdAt.split('T')[0]) ?? 'N/A'}</td>
                                                    <td
                                                        style={{
                                                            color:
                                                                row?.amountPaid?.isReserved ||
                                                                row?.amountPaid?.isInstallment
                                                                    ? 'red'
                                                                    : '',
                                                            textAlign: 'center',
                                                            whiteSpace: 'pre-line',
                                                            verticalAlign: 'middle'
                                                        }}
                                                    >
                                                        {row?.amountPaid?.isReserved || row?.amountPaid?.isInstallment
                                                            ? `${row?.amountPaid?.isReserved ? 'Reserved' : 'Installment'}\n${
                                                                  row?.amountPaid?.isReserved
                                                                      ? `(₹${row?.amountPaid?.reserve}/seat)`
                                                                      : row?.amountPaid?.isInstallment
                                                                        ? `(₹${row?.amountPaid?.installments?.[0]?.amount})`
                                                                        : ''
                                                              }
                                                                                                    Total: ${row?.amountPaid?.total}
                                                                                                    Paid: ${row?.amountPaid?.paid - (row?.amountPaid?.paid > row?.amountPaid?.reserve * row?.totalSeats ? getTransationCharges(row?.amountPaid?.reserve * row?.totalSeats) : 0)}
                                                                                                    Balance: ${row?.amountPaid?.total - row?.amountPaid?.reserve * row?.totalSeats}`
                                                            : <>Full payment<br />Paid: ₹{Number(row?.amountPaid?.paid) || 0}</>}
                                                    </td>
                                                    <td>{row.totalSeats}</td>
                                                    <td>{row.totalRooms}</td>
                                                    <td>
                                                        {row.transport === 'With transport' ? 'Included' : 'Excluded'}
                                                    </td>
                                                    <td>{row.bookedVia ?? 'N/A'}</td>
                                                    <td>{getUserDetails(row)}</td>
                                                    <td
                                                        style={
                                                            row?.tripStatus === 'Cancelled'
                                                                ? { color: 'red', fontWeight: '600' }
                                                                : {}
                                                        }
                                                    >
                                                        {row?.tripStatus}
                                                    </td>
                                                </>
                                            ) : (
                                                <>
                                                    <td>{getTripDetails(row)}</td>
                                                    <td>{row?.userDetails?.[0]?.name}</td>
                                                    <td>{row.startCity ?? 'N/A'}</td>
                                                    <td>{truncateText(row.pickupLocation, 40) ?? 'N/A'}</td>
                                                    <td>{standardDate(row?.createdAt?.split('T')[0])}</td>
                                                    <td>{row?.totalSeats ?? '0'}</td>
                                                    <td>{row?.customTrip?.rooms.length ?? '0'}</td>
                                                    <td>{row?.customTrip?.bed ?? '0'}</td>
                                                    <td
                                                        style={{
                                                            color:
                                                                row?.amountPaid?.isReserved ||
                                                                row?.amountPaid?.isInstallment
                                                                    ? 'red'
                                                                    : '',
                                                            textAlign: 'center',
                                                            verticalAlign: 'middle'
                                                        }}
                                                    >
                                                        {row?.amountPaid?.isReserved || row?.amountPaid?.isInstallment
                                                            ? `${row?.amountPaid?.isReserved ? 'Reserved' : 'Installment'}\n${
                                                                  row?.amountPaid?.isReserved
                                                                      ? `(₹${row?.amountPaid?.reserve}/seat)`
                                                                      : row?.amountPaid?.isInstallment
                                                                        ? `(₹${row?.amountPaid?.installments?.[0]?.amount})`
                                                                        : ''
                                                              }
                                                                                                    Total: ${row?.amountPaid?.total}
                                                                                                    Paid: ${row?.amountPaid?.paid - (row?.amountPaid?.paid > row?.amountPaid?.reserve * row?.totalSeats ? getTransationCharges(row?.amountPaid?.reserve * row?.totalSeats) : 0)}
                                                                                                    Balance: ${row?.amountPaid?.total - row?.amountPaid?.reserve * row?.totalSeats}`
                                                            : <>Full payment<br />Paid: ₹{Number(row?.amountPaid?.paid) || 0}</>}
                                                    </td>
                                                    <td>{row?.customTrip?.isGroup ? 'Yes' : 'No'}</td>
                                                    <td>{row?.transport ?? 'N/A'}</td>
                                                    <td>{row?.bookedVia ?? 'N/A'}</td>
                                                    <td>{getUserDetails(row)}</td>
                                                    <td
                                                        style={
                                                            row?.tripStatus === 'Cancelled'
                                                                ? { color: 'red', fontWeight: '600' }
                                                                : {}
                                                        }
                                                    >
                                                        {row?.tripStatus}
                                                    </td>
                                                </>
                                            )}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <div className='responsiveCardContainer'>
                            {bookings?.map((row, rowIndex) => (
                                <div key={rowIndex} className='responsiveCard'>
                                    <div className='cardContent'>
                                        <p>
                                            <strong>{tableHeader[0]}:</strong> {getTripDetails(row)}
                                        </p>
                                        <p className='bookingCardLabelDisplay'>
                                            <strong>{tableHeader[1]}:</strong> {row?.userDetails[0]?.name}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[2]}:</strong> {row.startCity ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[3]}:</strong> {row.pickupLocation ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[4]}:</strong>{' '}
                                            {standardDate(row?.createdAt?.split('T')[0])}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[5]}:</strong>{' '}
                                            {row?.amountPaid?.isReserved || row?.amountPaid?.isInstallment
                                                ? `${row?.amountPaid?.isReserved ? 'Reserved' : 'Installment'}\n${
                                                      row?.amountPaid?.isReserved
                                                          ? `(₹${row?.amountPaid?.reserve}/seat)`
                                                          : row?.amountPaid?.isInstallment
                                                            ? `(₹${row?.amountPaid?.installments?.[0]?.amount})`
                                                            : ''
                                                  }
                                                                                       Total: ${row?.amountPaid?.total}
                                                                                       Paid: ${row?.amountPaid?.paid - (row?.amountPaid?.paid > row?.amountPaid?.reserve * row?.totalSeats ? getTransationCharges(row?.amountPaid?.reserve * row?.totalSeats) : 0)}
                                                                                       Balance: ${row?.amountPaid?.total - row?.amountPaid?.reserve * row?.totalSeats}`
                                                : <>Full payment<br />Paid: ₹{Number(row?.amountPaid?.paid) || 0}</>}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[6]}:</strong> {row.totalSeats ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[7]}:</strong>
                                            {row.totalRooms}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[8]}:</strong>{' '}
                                            {row.transport === 'With transport' ? 'Included' : 'Excluded'}
                                            {/* {row.tripStatus ?? 'N/A'} */}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[9]}:</strong>
                                            {row.bookedVia ?? 'N/A'}
                                        </p>
                                        <p className={`${row?.userDetails?.length > 1 ? 'multiple' : ''}`}>
                                            <strong>{tableHeader[10]}:</strong>
                                            {getUserDetails(row)}
                                        </p>
                                        {/* {selectedType === 'upcoming' && (
                                            <div className='sendMessageBtn'>
                                                <button
                                                    className='actBtn payoutBtn noWidth'
                                                    onClick={() => {
                                                        setModal(true);
                                                        setRowData(row);
                                                    }}
                                                >
                                                    Send Message
                                                </button>
                                            </div>
                                        )} */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <Pagination
                    paginationClick={paginationClick}
                    numberOfRows={totalData}
                    offSet={offSet}
                    pageNumber={pageNumber}
                    limit={limit}
                />
                {modal && (
                    <Dialog openModal={modal} heading={'Send Message'}>
                        <div className='dialogContent'>
                            <select
                                name='date'
                                id='date'
                                className='select w-full'
                                value={'whatsApp'}
                                onChange={(e) =>
                                    setMessageData({
                                        ...messageData,
                                        msgType: e.target.value
                                    })
                                }
                                disabled
                            >
                                <option value=''>Select Message Type</option>
                                {messageType.map((type) => (
                                    <option value={type.value} key={type.value}>
                                        {type.name}
                                    </option>
                                ))}
                            </select>
                            {messageData.msgType === 'whatsApp' && (
                                <input
                                    placeholder='Whatsapp group link'
                                    name='whatsapp'
                                    onChange={(e) =>
                                        setMessageData({
                                            ...messageData,
                                            whatsApp: e.target.value
                                        })
                                    }
                                    value={messageData.whatsApp}
                                    className='whatsAppLink'
                                />
                            )}
                            {/* {messageData.msgType !== 'rate' &&
                                messageData.msgType !== 'whatsApp' && (
                                    <>
                                        <textarea
                                            className="messageArea"
                                            value={messageData.message}
                                            onChange={(e) =>
                                                setMessageData({
                                                    ...messageData,
                                                    message: e.target.value
                                                })
                                            }
                                        />
                                        <CharCount
                                            string={
                                                messageData.message
                                                    ? messageData.message
                                                    : ''
                                            }
                                            min={10}
                                            limit={50}
                                        />
                                    </>
                                )} */}
                            <p className='note'>
                                Note:{' '}
                                <span>The message will be sent to all the customers in this particular trip date</span>
                            </p>
                            <div className='alignCenter'>
                                <button className='dialogActBtn cancel' onClick={() => setModal(false)}>
                                    Cancel
                                </button>
                                <button
                                    className='dialogActBtn submit'
                                    disabled={!messageData.msgType}
                                    onClick={() =>
                                        sendMessage(
                                            {
                                                ...messageData,
                                                msgType: 'whatsapp',
                                                packDateId: rowData.packDateId
                                            },
                                            setLoading,
                                            setModal
                                        )
                                    }
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </Dialog>
                )}
            </div>
        </>
    );
};

export default OrgBooking;
